import Booking from "./Booking";
import Testimonials from "./Testimonials";
export default function Offers() {
    return (
      <>
      <div className="offer-page" id="offer-page">
    
        <section className="inner-banner-area rooms-hero">
          <img src="img/room-hero-banner.avif" className="w-100" />
          <div className="container">
            <div className="contact-banner">
                <div className="text-center">
                <h2 className="inner-banner-heading">Our Offers</h2>
                <nav aria-label="breadcrumb" className="banner-breadcrumb">
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="index.php">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">offers</li>
                    </ol>
                </nav>
                </div>
            </div>
            </div>
        </section>

        <Booking></Booking>



<section className="offer-page-section">
            <div className="container">
                <div className="section-intro text-center pb-80px">
                    <h1 className="inner-section-main-heading">Our Offers</h1>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-6 wow bounceInUp" data-wow-duration="2s">
                        <div className="latest-news-wrapper">
                            <div className="latest-news-inner">
                                <div className="latest-news clearfix">
                                    <figure><img src="img/hotel-offer.webp" alt="" className="img-fluid w-100" /></figure>
                                    <div className="caption">
                                        <div className="txt1">
                                            <a href="#">Hotel Offer</a>
                                        </div>
                                        <div className="txt2">Lorem ipsum dolor sit amet consetuer adipiscing elit, sed diam
                                            nonummy.Lorem ipsum dolor sit amet consetuer adipiscing elit, sed diam
                                            nonummy.
                                        </div>
                                        <div className="offer-cta-buttons">
                                            <a href="#" className="btn offer-book-now">Book Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 wow bounceInUp" data-wow-duration="3s">
                        <div className="latest-news-wrapper">
                            <div className="latest-news-inner">
                                <div className="latest-news clearfix">
                                    <figure><img src="img/hotel-offer.webp" alt="" className="img-fluid w-100" /></figure>
                                    <div className="caption">
                                        <div className="txt1">
                                            <a href="#">Hotel Offer</a>
                                        </div>
                                        <div className="txt2">Lorem ipsum dolor sit amet consetuer adipiscing elit, sed diam
                                            nonummy.Lorem ipsum dolor sit amet consetuer adipiscing elit, sed diam
                                            nonummy.
                                        </div>
                                        <div className="offer-cta-buttons">
                                            <a href="#" className="btn offer-book-now">Book Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 wow bounceInUp" data-wow-duration="2s">
                        <div className="latest-news-wrapper">
                            <div className="latest-news-inner">
                                <div className="latest-news clearfix">
                                    <figure><img src="img/hotel-offer.webp" alt="" className="img-fluid w-100" /></figure>
                                    <div className="caption">
                                        <div className="txt1">
                                            <a href="#">Hotel Offer</a>
                                        </div>
                                        <div className="txt2">Lorem ipsum dolor sit amet consetuer adipiscing elit, sed diam
                                            nonummy.Lorem ipsum dolor sit amet consetuer adipiscing elit, sed diam
                                            nonummy.
                                        </div>
                                        <div className="offer-cta-buttons">
                                            <a href="#" className="btn offer-book-now">Book Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 wow bounceInUp" data-wow-duration="3s">
                        <div className="latest-news-wrapper">
                            <div className="latest-news-inner">
                                <div className="latest-news clearfix">
                                    <figure><img src="img/hotel-offer.webp" alt="" className="img-fluid w-100" /></figure>
                                    <div className="caption">
                                        <div className="txt1">
                                            <a href="#">Hotel Offer</a>
                                        </div>
                                        <div className="txt2">Lorem ipsum dolor sit amet consetuer adipiscing elit, sed diam
                                            nonummy.Lorem ipsum dolor sit amet consetuer adipiscing elit, sed diam
                                            nonummy.
                                        </div>
                                        <div className="offer-cta-buttons">
                                            <a href="#" className="btn offer-book-now">Book Now</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
</div>

<Testimonials></Testimonials>

      </>
    );
  }
  